import Breadcrumb from '@ingka/breadcrumb';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { config } from '../config';
import { getBreadcrumbs, useAppContext } from '../contextProviders/AppContext';
import cssIngka from '@ingka/variables/colours-css';

const Wrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: 4rem;
  li > a > span {
    color: ${cssIngka.colourNeutral7};
  }
  li::after {
    color: ${cssIngka.colourNeutral7};
  }
`;

const Breadcrumbs = () => {
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const { country, language } = config;
  const breadcrumbs = useSelector(getBreadcrumbs);

  const baseUrl = `${window.location.origin}/${country}/${language}/stores/events`;

  const items = [
    {
      url: '',
      text: t('app.bcAllEvent'),
    },
    ...breadcrumbs,
  ].map((item) => ({
    ...item,
    url: `${baseUrl}/${item.url ? `${item.url}/` : ''}`,
  }));

  return (
    <Wrapper>
      <Breadcrumb items={items} />
    </Wrapper>
  );
};

export default Breadcrumbs;
